exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Album-local__album--2iz5G {\n  background-image: url(\"/img/folder_v2.svg\");\n  background-position: -4px 0;\n  background-repeat: no-repeat;\n  background-size: calc(100% + 8px);\n  height: 15.6rem; }\n", ""]);

// exports
exports.locals = {
	"album": "Album-local__album--2iz5G"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Common/AlbumFetching/Album.local.scss
// module id = 466
// module chunks = 0